import { SubNavbar } from "components"
import { useEffect, useState } from "react"
import { Box } from "theme-ui"
import { Link } from "react-router-dom"
import { INav } from "@types"
import { useTranslation } from "react-i18next"

export const Navbar = () => {
 const { t } = useTranslation("translation")
 const nav: INav[] = t("navigation", { returnObjects: true })
 // state for opening of the navbar menu
 const [parentMenuIndex, setParentMenuIndex] = useState<string | null>("")
 // state for navbar background blur in small devices
 const [blur, setBlur] = useState<boolean>(false)
 // method for navbar background blur in small devices
 const isBLur = () => {
  if (parentMenuIndex !== null) {
   setBlur(!blur)
  }
 }

 useEffect(() => {
  isBLur()
  // eslint-disable-next-line
 }, [parentMenuIndex])

 return (
  <Box
   className="h-screen lg:h-full lg-pt-0 pt-5"
   color="text"
   sx={{ stroke: "stroke" }}
   bg="highlight"
  >
   {/* ====================== navbar-list-start =========================== */}
   <ul className="flex items-center gap-10">
    {/* =========== onMouseEnter-&-onMouseLeave-function for opeining and closing subMenu ================= */}
    <div className="flex lg:flex lg:flex-row flex-col lg:px-0 px-3 lg:items-center gap-10">
     {nav?.map(({ name, slug, subNav }: INav, index: number) =>
      slug === "" ? (
       <div
        key={index}
        onMouseEnter={() => {
         setParentMenuIndex(name)
        }}
        onMouseLeave={() => {
         setParentMenuIndex("")
        }}
        className="flex relative items-center gap-2"
       >
        <div className={` ${blur !== true ? "blur-[2px] lg:blur-[0]" : ""}`}>
         <li
          className={`cursor-pointer ${parentMenuIndex === name ? "text-yellow" : "color='text'"}`}
         >
          {name}
         </li>
        </div>
        {parentMenuIndex === name ? (
         <div className="cursor-pointer">
          <svg
           xmlns="http://www.w3.org/2000/svg"
           width="9"
           height="6"
           viewBox="0 0 9 6"
           fill="none"
          >
           <path
            d="M1.73506 4.56152L4.85776 1.43882L7.98047 4.56152"
            stroke="rgba(255, 184, 47, 2)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
           />
          </svg>
         </div>
        ) : (
         <div className="cursor-pointer">
          {/* ======== arrow-down-svg ======== */}
          <svg
           xmlns="http://www.w3.org/2000/svg"
           width="10"
           height="6"
           viewBox="0 0 10 6"
           fill="none"
          >
           <path
            d="M8.22783 1.43848L5.10513 4.56118L1.98242 1.43848"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
           />
          </svg>
         </div>
        )}
        {/* =============  opening-subMenu-component with subMenu state ===================== */}
        {parentMenuIndex === name && (
         <div className="absolute lg:top-5 top-0 lg:left-0 left-24">
          <div className="relative border lg:top-12 top-5">
           {/* ==================== calling-InfoSubMenu-component ======================== */}
           <SubNavbar nav={subNav} />
          </div>
         </div>
        )}
       </div>
      ) : (
       <Link
       key={index}
        className={`hover:text-yellow ${blur !== true ? "blur-[2px] lg:blur-[0]" : ""}`}
        to={"/" + slug}
       >
        {name}
       </Link>
      ),
     )}
    </div>
   </ul>
  </Box>
 )
}
